// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TpsE","colBig":"styles_colBig__1DSHS","colSmall":"styles_colSmall__1tUYy"};